import React from 'react';
import { withYMaps } from 'react-yandex-maps';
import {
  object, func, shape,
} from 'prop-types';
import { renderToString } from 'react-dom/server';
import classNames from 'classnames/bind';
import s from './index.module.css';

const cx = classNames.bind(s);

export const ZOOM_IN_BUTTON_ID = 'zoomInButton';
export const ZOOM_OUT_BUTTON_ID = 'zoomOutButton';

const zoomComponent = (
  <div className={s.container}>
    <button type="button" className={cx(s.zoomInButton, s.button)} id={ZOOM_IN_BUTTON_ID}/>
    <button type="button" className={cx(s.zoomOutButton, s.button)} id={ZOOM_OUT_BUTTON_ID}/>
  </div>
);

const TemplateProvider = ({ ymaps, children }) => {
  const zoomLayout = ymaps.templateLayoutFactory.createClass(
    renderToString(zoomComponent), {
      build() {
        zoomLayout.superclass.build.call(this);
        this.zoomInCallback = () => {     
          const map = this.getData().control.getMap();
          const nextZoom = map.getZoom() + 1;
          map.setZoom(nextZoom, { checkZoomRange: true });
        };
        this.zoomOutCallback = () => {
          const map = this.getData().control.getMap();
          const nextZoom = map.getZoom() - 1;
          map.setZoom(nextZoom, { checkZoomRange: true });
        };

        document.getElementById(ZOOM_IN_BUTTON_ID).addEventListener('click', this.zoomInCallback);
        document.getElementById(ZOOM_OUT_BUTTON_ID).addEventListener('click', this.zoomOutCallback);
      },
      clear() {
        if (!document.getElementById(ZOOM_IN_BUTTON_ID)) {
          return;
        }
        document.getElementById(ZOOM_IN_BUTTON_ID).removeEventListener('click', this.zoomInCallback);
        document.getElementById(ZOOM_OUT_BUTTON_ID).removeEventListener('click', this.zoomOutCallback);
        zoomLayout.superclass.clear.call(this);
      },
    },
  );

  return children({ template: zoomLayout });
}

TemplateProvider.propTypes = {
  children: func,
  ymaps: shape({ templateLayoutFactory: object }),
};

TemplateProvider.defaultProps = {
  children: null,
  ymaps: null
};

const ZoomTemplateProvider = withYMaps(TemplateProvider, true, [
  'templateLayoutFactory',
]);

export default ZoomTemplateProvider;